import DataTable from "pages/components/DataTable";
import DropdownMenu from "../DropdownMenu";
import { getAPIURL, getFormattedDate, sendAPIRequest } from "helpers";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import IssueAssignmentModal from "./IssueAssignmentModal";
import { useSelector } from "react-redux";


const RaiseAnIssue = ({ missionId }) => {
    const [data, setData] = useState([]);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedIssueId, setSelectedIssueId] = useState(null);
    const authToken = useSelector((s) => s.auth.accessToken);

    useEffect(() => {
        loadData();
    }, [isModalVisible]);

    const loadData = async () => {
        try {
            setIsLoading(true);
            const ret = await sendAPIRequest(`/api/reported-issues/${missionId}`);
            const res = await ret.json();
            if (res.success && res.status === 200) {
                setData(res.data);
                setIsLoading(false);
            }
        } catch (err) {
            console.log({ err });
        }
    };

    return (
        <>
            <div className="card card-woah border border-secondary shadow-sm rounded-0">
                <div className="card-body p-4">
                    <DataTable
                        getRowId={(row) => row.id}
                        isLoading={isLoading}
                        className="text-white bg-primary rounded-0"
                        rows={data}
                        columns={[
                            {
                                field: "user",
                                headerName: t("-1", "Reported User"),
                                headerClassName: "text-white bg-primary rounded-0",
                                valueGetter: (params) => params.row?.user?.name,
                                minWidth: 110,
                                flex: 1,
                            },
                            {
                                field: "issue_type",
                                headerName: t("-1", "Submission Type"),
                                headerClassName: "text-white bg-primary rounded-0",
                                minWidth: 110,
                                flex: 1,
                            },
                            {
                                field: "mission_type",
                                headerName: t("-1", "Mission Type"),
                                headerClassName: "text-white bg-primary rounded-0",
                                width: 100,
                            },
                            {
                                field: "form_name",
                                headerName: t("-1", "Form Name"),
                                headerClassName: "text-white bg-primary rounded-0",
                                width: 120,
                            },
                            {
                                field: "description",
                                headerName: t("-1", "Description"),
                                headerClassName: "text-white bg-primary rounded-0",
                                minWidth: 130,
                                flex: 2,
                                renderCell: (params) => {
                                    const fullText = params.value || "";
                                    const isLong = fullText.length > 80;
                                    const displayText = showMore ? fullText : fullText.slice(0, 80);
                                    return (
                                        <div>
                                            {displayText}
                                            {isLong && (
                                                <span
                                                    style={{ color: "#007bff", cursor: "pointer", marginLeft: 5 }}
                                                    onClick={() => setShowMore(!showMore)}
                                                >
                                                    {showMore ? " Show less" : "... Show more"}
                                                </span>
                                            )}
                                        </div>
                                    );
                                },
                            },
                            {
                                field: "attachment",
                                headerName: t("-1", "Attachment"),
                                headerClassName: "text-white bg-primary rounded-0",
                                valueGetter: (params) => params.row?.attachment ? params.row?.attachment  : "No files attached",
                                minWidth: 130,
                                flex: 1,
                            },
                            {
                                field: "severity",
                                headerName: t("-1", "Severity"),
                                headerClassName: "text-white bg-primary rounded-0",
                                width: 100,
                            },
                            {
                                field: "priority",
                                headerName: t("-1", "Priority"),
                                headerClassName: "text-white bg-primary rounded-0",
                                width: 100,
                            },
                            {
                                field: "createdAt",
                                headerName: t("-1", "Created Date"),
                                headerClassName: "text-white bg-primary rounded-0",
                                valueFormatter: ({ value }) => getFormattedDate(value),
                            },
                            {
                                field: "status",
                                headerName: t("-1", "Status"),
                                headerClassName: "text-white bg-primary rounded-0",
                                renderCell: (params) => {
                                    if (params.value === 1) return "Level 1";
                                    if (params.value === 2) return "Level 2";
                                    if (params.value === 3) return "Resolved";
                                    return "Unknown";
                                },
                            },
                            {
                                field: "actions",
                                headerName: t("-1", "Actions"),
                                headerClassName: "text-white bg-primary rounded-0",
                                renderCell: (params) => {
                                    const isResolved = params.row.status === 3;
                                    const isAttachment = params.row.attachment !== null;
                                    const menuItems = [];
                                    if (isAttachment) {
                                        menuItems.push(
                                            {
                                                text: "Download Attachment",
                                                onClick: () => {
                                                    window.open(
                                                        getAPIURL(`/api/reported-issues/download/${params.row.id}?_token=${authToken}`),
                                                        "_blank"
                                                    );
                                                },
                                            },
                                        )
                                    }
                                    if (!isResolved) {
                                        menuItems.unshift({
                                            text: "Assign",
                                            onClick: () => {
                                                setSelectedIssueId(params.row.id);
                                                setIsModalVisible(true);
                                            },
                                        });

                                        menuItems.push({
                                            text: "Resolved",
                                            onClick: () => {
                                                fetch(getAPIURL(`/api/reported-issues/resolved/${params.row.id}?_token=${authToken}`), {
                                                    method: "GET",
                                                })
                                                    .then((response) => {
                                                        if (!response.ok) {
                                                            throw new Error("Network response was not ok");
                                                        }
                                                        return response.json();
                                                    })
                                                    .then((data) => {
                                                        console.log("Issue resolved:", data);
                                                    })
                                                    .catch((error) => {
                                                        console.error("Error resolving issue:", error);
                                                    });
                                            },
                                        });
                                    }

                                    return <DropdownMenu items={menuItems} color="primary" />;
                                },
                            }

                        ]}

                    />
                </div>
            </div>
            <IssueAssignmentModal
                isShow={isModalVisible}
                initModal={() => setIsModalVisible(false)}
                issueId={selectedIssueId}
            />
        </>
    );
}

export default RaiseAnIssue
